module.exports = __webpack_public_path__ + "img/hiring.661295d3.svg";